import { ApplicabilityReasons, ControlTypes } from 'models/control';
import EntityDTO from 'models/dto/entityDTO';
import TaskDTO from 'models/dto/tasks/taskDTO';
import { EntityStatus } from 'models/entityStatus';
import { TagSystemTypes } from 'models/tag';
import { newGuidNil } from 'utils/guid';
import Control_TranslationDTO from './control_TranslationDTO';
import DashboardDTO from './dashboardDTO';
import IdListDTO from './IdListDTO';
import ISOControlDTO from './isoControlDTO';
import NormControlDTO from './normControlDTO';

export default class ControlDTO {
  tenantId: string;

  controlId: number;

  code: string;

  parentControlId?: number;

  controlType?: ControlTypes;

  recurringPattern?: string;

  state: EntityStatus;

  applicabilityReason: IdListDTO;

  groupId?: string;

  ownerId?: string;

  ownerRoleId?: string;

  commentTrailId: number;

  auditTrailId: number;

  normIds?: IdListDTO;

  isoControlIds?: IdListDTO;

  dashboard?: DashboardDTO;

  inheritTenantId?: string;

  inheritControlId?: number;

  latestChangeDateTime?: string;

  trans?: Control_TranslationDTO[];

  tasks?: TaskDTO[];

  tagIds?: IdListDTO;

  monitoringParent?: EntityDTO;

  isoControls?: ISOControlDTO[];

  riskIds?: IdListDTO;

  updateChildControls?: boolean;

  unmonitored: boolean;

  perNormData?: boolean;

  normControls?: NormControlDTO[];

  constructor() {
    this.tenantId = newGuidNil();
    this.controlId = 0;
    this.code = '';
    this.commentTrailId = 0;
    this.auditTrailId = 0;
    this.state = EntityStatus.Todo;
    this.applicabilityReason = new IdListDTO([ApplicabilityReasons.Basic.toString()]);
    this.unmonitored = false;
  }
}


export class ControlDashboardDTO {
  controlId: number = 0;

  totalTaskOpenCount: number = 0;

  monitoringTaskCount: number = 0;

  monitoringTaskOpenCount: number = 0;

  integrationRunCount: number = 0;

  integrationRunDeadCount: number = 0;

  tagSystemTypeCount: Record<TagSystemTypes, number>;

  tagOtherCount: Record<number, number>;

  constructor() {
    this.tagSystemTypeCount = {} as Record<TagSystemTypes, number>;
    this.tagOtherCount = {} as Record<number, number>;
  }
}
